const MAX_CONTENT_DEPTH = 7;

export const getFormattedDataIfNeeded = (array) => {
    if (!array.length) {
        return [];
    }

    if (array.length <= MAX_CONTENT_DEPTH) {
        return array;
    }

    array.length = MAX_CONTENT_DEPTH;

    return array;
};
